<template>
  <Modal
    :id="'cmp-royalty-contracts-sidewindow-royalty_rate_digital_form'"
    @cancelled="onCancel"
  >
    <!-- <template slot="header">{{ $dft.snakeCaseToWords('new_track_additional') }}</template> -->
    <template slot="header">Edit Payment</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            :id="'payment_date'"
            class="m1"
            v-bind="textFieldConfig"
            type="date"
            :value="selectedPayment.payment_date"
            required
            showValidationIcons
            :placeholder="$t('payment_date')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'matching_date'"
            class="m1"
            v-bind="textFieldConfig"
            type="date"
            :value="selectedPayment.matching_date"
            required
            showValidationIcons
            :placeholder="$t('matching_date')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'amount'"
            class="m1"
            v-bind="textFieldConfig"
            :value="selectedPayment.amount"
            required
            showValidationIcons
            :placeholder="$t('amount')"
            @valuechanged="onTextFieldValueChange"
          />
        </div>
      </div>
    </template>

    <template slot="options">
      <button @click.stop="onUndoClick" class="dt-button v1 with-ico s6">
        <div class="button-text">Undo Payment</div>
      </button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">Ok</button>
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import { AccountsService } from "../../services/accounts.service";
import { accountsRoyaltyGetters } from "../../store/accounts/getters";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
export default {
  components: {
    Modal,
    InputField,
  },

  props: ["selectedAccountDetails", "selectedPayment"],
  data() {
    return {
      payment_info: { payment_date: null, matching_date: null, amount: 0.0 },
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
      },
      validationResult: {},
    };
  },
  computed: {
    royalty_account_id: function () {
      return this.$route.params.royalty_account_id;
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    onOkClick: async function () {
      this.selectedPayment.payment_amount = this.selectedPayment.amount;
      const res = await AccountsService.modifyPayment({
        ...this.selectedPayment,
      });

      this.$emit("added", this.selectedPayment);
    },
    onUndoClick: async function () {
      this.selectedPayment.payment_amount = null;
      this.selectedPayment.matching_date = null;
      this.selectedPayment.payment_date = null;
      const res = await AccountsService.undoPayment({
        ...this.selectedPayment,
      });

      this.$emit("added", this.selectedPayment);
    },
    onTextFieldValueChange: function (name, value) {
      this.selectedPayment[name] = value;
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-royalty_rate_digital_form {
  // border: 1px solid var(--sprt-5);
}
</style>
